import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { catchError, map, switchMap, of } from 'rxjs';
import { environment } from '../../../environment/environment';

export function delete_template(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: { template_id: number }
) {
  const templateId = data.template_id;
  if (!templateId) {
    throw new Error('Manglende skabelon-id');
  }

  const request$ = componentDataDestService.http
    .delete(`${environment.apiUrl}/duna_templates/${templateId}`)
    .pipe(
      catchError((error) => {
        console.error('[delete_template] Error:', error);
        throw error;
      }),
      switchMap((response) =>
        componentDataSourceService.updateStoreData(of(response), 'templates').pipe(
          map(() => response)
        )
      )
    );

  return request$;
}
